import { Autocomplete, Button, Chip, TextField, Typography } from "@mui/material";
import axios from "axios";
import { useEffect, useMemo, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { useImmer } from "use-immer";
import {
    ALARM_WEBSOCKET_PATH,
    APP_BASE_URL,
    APP_BASE_URL_ALARM,
    APP_BASE_URL_ALARM_SOCKET,
    GET_ACTIVE_ALARMS,
    GET_PAGINATED_ALARMS,
    PLATFORM_SVG_FOR_STATION,
} from "../../Common/EndPoints";
import { extractParsedDataFromPermissions } from "../../Utils/Utils";
import { getParsedLocalStorage } from "../../Utils/storage-utils";
import { useGetDeviceTypesQuery } from "../../features/SearchFilters/searchFiltersSlice";
import { selectedCustomersSelector } from "../../features/authentication/auth-slice";
import { AutocompleteStationListPop } from "../AutocompleteStationListPop/AutocompleteStationListPop";
import "./platformsvg.scss";
import TravelExploreIcon from '@mui/icons-material/TravelExplore';

const dummyAlarm = [
    {
        id: "8884e2f3-2f0c-45ce-b29c-236175c43532",
        created_dt: "2025-06-17T07:06:50.738543Z",
        clear_dt: null,
        ack_dt: null,
        type: "SMPS Low input Voltage(Critical)",
        category: "Information",
        create_info: {
            description: "Low SMPS input Voltage",
        },
        device_id: "281e5af6-a4a5-4506-9171-b2b97449eeec",
        customer_id: "499c0695-60b8-4d37-b7ee-42fa0a02ca1b",
        acked_by: null,
        acked_info: null,
        is_active: false,
        severity: "CRITICAL",
        updated_dt: "2025-06-17T08:41:02.510822Z",
        clear_info: {
            description: "Values restored to Normal",
        },
        event_count: 49,
        create_value: {
            VIN: "0.00V",
        },
        clear_value: {
            VIN: "236.87V",
        },
        update_value: {
            VIN: "0.00V",
        },
        device: {
            id: "281e5af6-a4a5-4506-9171-b2b97449eeec",
            name: "NCR_PRYJ_PCOI_SLDB-5-PF2",
            is_test_mode: false,
            device_type_id: "e8d8d063-f465-409d-8a8a-2a57f1019247",
            is_logical: false,
            software_id: "c575cc67-354a-4a3a-b66a-7d902f1e4a7b",
            latitude: 28.5876854,
            longitude: 77.4959564,
            customer: null,
            device_type: {
                typeid: "e8d8d063-f465-409d-8a8a-2a57f1019247",
                type: "SMPS",
                label: "SMPS Charger",
            },
            software: {
                id: "c575cc67-354a-4a3a-b66a-7d902f1e4a7b",
                code: "SDH&PDH",
                alias: "SDH&PDH",
                additional_info: {},
            },
        },
        customer: {
            id: "499c0695-60b8-4d37-b7ee-42fa0a02ca1b",
            zone: "NCR",
            division: "PRYJ",
            station: "MIU",
            title: null,
            devices: null,
        },
        acked_user: null,
        fmeas: null,
    },
    {
        id: "546b8d19-1d25-46b0-af79-08675ff00516",
        created_dt: "2025-06-17T05:45:04.657794Z",
        clear_dt: null,
        ack_dt: null,
        type: "SMPS Low output Voltage(Critical)",
        category: "Information",
        create_info: {
            description: "Low SMPS output Voltage",
        },
        device_id: "67689f77-f13e-469c-a162-14b5c23d5782",
        customer_id: "05988942-ed90-4f89-8ab6-e22191ac9532",
        acked_by: null,
        acked_info: null,
        is_active: false,
        severity: "CRITICAL",
        updated_dt: "assasas",
        clear_info: {
            description: "Values restored to Normal",
        },
        event_count: 1,
        create_value: {
            VOUT: "46.98V",
        },
        clear_value: {
            VOUT: "50.87V",
        },
        update_value: null,
        device: {
            id: "67689f77-f13e-469c-a162-14b5c23d5782",
            name: "NCR_PRYJ_PCOI_SLDB-5-PF2",
            is_test_mode: false,
            device_type_id: "e8d8d063-f465-409d-8a8a-2a57f1019247",
            is_logical: false,
            software_id: "f3d1f3ba-b167-4f16-a7e9-696f8c18d760",
            latitude: 28.5394405,
            longitude: 77.5373917,
            customer: null,
            device_type: {
                typeid: "e8d8d063-f465-409d-8a8a-2a57f1019247",
                type: "SMPS",
                label: "SMPS Charger",
            },
            software: {
                id: "f3d1f3ba-b167-4f16-a7e9-696f8c18d760",
                code: "MTRC System",
                alias: "MTRC System",
                additional_info: null,
            },
        },
        customer: {
            id: "05988942-ed90-4f89-8ab6-e22191ac9532",
            zone: "NCR",
            division: "PRYJ",
            station: "DER",
            title: null,
            devices: null,
        },
        acked_user: null,
        fmeas: null,
    },
    {
        id: "a30f9830-468c-4fb8-b524-b94d3d19fd3b",
        created_dt: "2025-06-17T04:45:41.544522Z",
        clear_dt: "2025-06-17T06:10:50.012058Z",
        ack_dt: null,
        type: "SMPS Low input Voltage(Critical)",
        category: "Information",
        create_info: {
            description: "Low SMPS input Voltage",
        },
        device_id: "67689f77-f13e-469c-a162-14b5c23d5782",
        customer_id: "05988942-ed90-4f89-8ab6-e22191ac9532",
        acked_by: null,
        acked_info: null,
        is_active: false,
        severity: "CRITICAL",
        updated_dt: "2025-06-17T05:45:03.624589Z",
        clear_info: {
            description: "Values restored to Normal",
        },
        event_count: 36,
        create_value: {
            VIN: "0.00V",
        },
        clear_value: {
            VIN: "208.59V",
        },
        update_value: {
            VIN: "0.00V",
        },
        device: {
            id: "67689f77-f13e-469c-a162-14b5c23d5782",
            name: "NCR_PRYJ_DER_MTRC",
            is_test_mode: false,
            device_type_id: "e8d8d063-f465-409d-8a8a-2a57f1019247",
            is_logical: false,
            software_id: "f3d1f3ba-b167-4f16-a7e9-696f8c18d760",
            latitude: 28.5394405,
            longitude: 77.5373917,
            customer: null,
            device_type: {
                typeid: "e8d8d063-f465-409d-8a8a-2a57f1019247",
                type: "SMPS",
                label: "SMPS Charger",
            },
            software: {
                id: "f3d1f3ba-b167-4f16-a7e9-696f8c18d760",
                code: "MTRC System",
                alias: "MTRC System",
                additional_info: null,
            },
        },
        customer: {
            id: "05988942-ed90-4f89-8ab6-e22191ac9532",
            zone: "NCR",
            division: "PRYJ",
            station: "DER",
            title: null,
            devices: null,
        },
        acked_user: null,
        fmeas: null,
    },
    {
        id: "de669014-4304-4674-b51b-ea8e2beb2ce2",
        created_dt: "2025-06-16T07:41:44.070789Z",
        clear_dt: "2025-06-16T09:32:13.629054Z",
        ack_dt: null,
        type: "SMPS Low input Voltage(Critical)",
        category: "Information",
        create_info: {
            description: "Low SMPS input Voltage",
        },
        device_id: "292ae68e-3a5b-4f38-b578-9f63d3dd07d1",
        customer_id: "05988942-ed90-4f89-8ab6-e22191ac9532",
        acked_by: null,
        acked_info: null,
        is_active: false,
        severity: "CRITICAL",
        updated_dt: "2025-06-16T08:30:05.448964Z",
        clear_info: {
            description: "Values restored to Normal",
        },
        event_count: 24,
        create_value: {
            VIN: "0.00V",
        },
        clear_value: {
            VIN: "200.63V",
        },
        update_value: {
            VIN: "0.00V",
        },
        device: {
            id: "292ae68e-3a5b-4f38-b578-9f63d3dd07d1",
            name: "NCR_PRYJ_DER_EXCHANGE",
            is_test_mode: false,
            device_type_id: "e8d8d063-f465-409d-8a8a-2a57f1019247",
            is_logical: false,
            software_id: "a5e23c53-9b72-4af2-8f69-9e450cba5651",
            latitude: 28.5392797,
            longitude: 77.537247,
            customer: null,
            device_type: {
                typeid: "e8d8d063-f465-409d-8a8a-2a57f1019247",
                type: "SMPS",
                label: "SMPS Charger",
            },
            software: {
                id: "a5e23c53-9b72-4af2-8f69-9e450cba5651",
                code: "Auto Exchange",
                alias: "Auto Exchange",
                additional_info: null,
            },
        },
        customer: {
            id: "05988942-ed90-4f89-8ab6-e22191ac9532",
            zone: "NCR",
            division: "PRYJ",
            station: "DER",
            title: null,
            devices: null,
        },
        acked_user: null,
        fmeas: null,
    },
    {
        id: "b89bc17b-8ee3-4c5a-bc8e-4dd17d94bd24",
        created_dt: "2025-06-16T04:55:15.238481Z",
        clear_dt: "2025-06-16T05:22:04.772338Z",
        ack_dt: null,
        type: "SMPS Low output Voltage(Critical)",
        category: "Information",
        create_info: {
            description: "Low SMPS output Voltage",
        },
        device_id: "67689f77-f13e-469c-a162-14b5c23d5782",
        customer_id: "05988942-ed90-4f89-8ab6-e22191ac9532",
        acked_by: null,
        acked_info: null,
        is_active: false,
        severity: "CRITICAL",
        updated_dt: "2025-06-16T04:59:05.047262Z",
        clear_info: {
            description: "Values restored to Normal",
        },
        event_count: 3,
        create_value: {
            VOUT: "46.98V",
        },
        clear_value: {
            VOUT: "53.52V",
        },
        update_value: {
            VOUT: "46.01V",
        },
        device: {
            id: "67689f77-f13e-469c-a162-14b5c23d5782",
            name: "NCR_PRYJ_DER_MTRC",
            is_test_mode: false,
            device_type_id: "e8d8d063-f465-409d-8a8a-2a57f1019247",
            is_logical: false,
            software_id: "f3d1f3ba-b167-4f16-a7e9-696f8c18d760",
            latitude: 28.5394405,
            longitude: 77.5373917,
            customer: null,
            device_type: {
                typeid: "e8d8d063-f465-409d-8a8a-2a57f1019247",
                type: "SMPS",
                label: "SMPS Charger",
            },
            software: {
                id: "f3d1f3ba-b167-4f16-a7e9-696f8c18d760",
                code: "MTRC System",
                alias: "MTRC System",
                additional_info: null,
            },
        },
        customer: {
            id: "05988942-ed90-4f89-8ab6-e22191ac9532",
            zone: "NCR",
            division: "PRYJ",
            station: "DER",
            title: null,
            devices: null,
        },
        acked_user: null,
        fmeas: null,
    },
    {
        id: "1986f9f1-0da4-41ec-886c-b1e892caf5d4",
        created_dt: "2025-06-16T04:38:58.656186Z",
        clear_dt: "2025-06-16T07:41:40.467302Z",
        ack_dt: null,
        type: "SMPS Low input Voltage(Critical)",
        category: "Information",
        create_info: {
            description: "Low SMPS input Voltage",
        },
        device_id: "67689f77-f13e-469c-a162-14b5c23d5782",
        customer_id: "05988942-ed90-4f89-8ab6-e22191ac9532",
        acked_by: null,
        acked_info: null,
        is_active: false,
        severity: "CRITICAL",
        updated_dt: "2025-06-16T05:23:04.085722Z",
        clear_info: {
            description: "Values restored to Normal",
        },
        event_count: 16,
        create_value: {
            VIN: "0.00V",
        },
        clear_value: {
            VIN: "205.05V",
        },
        update_value: {
            VIN: "0.00V",
        },
        device: {
            id: "67689f77-f13e-469c-a162-14b5c23d5782",
            name: "NCR_PRYJ_DER_MTRC",
            is_test_mode: false,
            device_type_id: "e8d8d063-f465-409d-8a8a-2a57f1019247",
            is_logical: false,
            software_id: "f3d1f3ba-b167-4f16-a7e9-696f8c18d760",
            latitude: 28.5394405,
            longitude: 77.5373917,
            customer: null,
            device_type: {
                typeid: "e8d8d063-f465-409d-8a8a-2a57f1019247",
                type: "SMPS",
                label: "SMPS Charger",
            },
            software: {
                id: "f3d1f3ba-b167-4f16-a7e9-696f8c18d760",
                code: "MTRC System",
                alias: "MTRC System",
                additional_info: null,
            },
        },
        customer: {
            id: "05988942-ed90-4f89-8ab6-e22191ac9532",
            zone: "NCR",
            division: "PRYJ",
            station: "DER",
            title: null,
            devices: null,
        },
        acked_user: null,
        fmeas: null,
    },
    {
        id: "aaa3dd94-12de-44b9-a344-7cdcf2bc813d",
        created_dt: "2025-06-14T10:49:16.915183Z",
        clear_dt: "2025-06-14T11:12:16.698559Z",
        ack_dt: null,
        type: "SMPS Low output Voltage(Critical)",
        category: "Information",
        create_info: {
            description: "Low SMPS output Voltage",
        },
        device_id: "67689f77-f13e-469c-a162-14b5c23d5782",
        customer_id: "05988942-ed90-4f89-8ab6-e22191ac9532",
        acked_by: null,
        acked_info: null,
        is_active: false,
        severity: "CRITICAL",
        updated_dt: null,
        clear_info: {
            description: "Values restored to Normal",
        },
        event_count: 1,
        create_value: {
            VOUT: "46.84V",
        },
        clear_value: {
            VOUT: "49.62V",
        },
        update_value: null,
        device: {
            id: "67689f77-f13e-469c-a162-14b5c23d5782",
            name: "NCR_PRYJ_DER_MTRC",
            is_test_mode: false,
            device_type_id: "e8d8d063-f465-409d-8a8a-2a57f1019247",
            is_logical: false,
            software_id: "f3d1f3ba-b167-4f16-a7e9-696f8c18d760",
            latitude: 28.5394405,
            longitude: 77.5373917,
            customer: null,
            device_type: {
                typeid: "e8d8d063-f465-409d-8a8a-2a57f1019247",
                type: "SMPS",
                label: "SMPS Charger",
            },
            software: {
                id: "f3d1f3ba-b167-4f16-a7e9-696f8c18d760",
                code: "MTRC System",
                alias: "MTRC System",
                additional_info: null,
            },
        },
        customer: {
            id: "05988942-ed90-4f89-8ab6-e22191ac9532",
            zone: "NCR",
            division: "PRYJ",
            station: "DER",
            title: null,
            devices: null,
        },
        acked_user: null,
        fmeas: null,
    },
    {
        id: "ea62aff8-7e80-4c06-a445-6ae6f7e6ccd9",
        created_dt: "2025-06-14T09:50:59.603584Z",
        clear_dt: "2025-06-14T11:27:18.752265Z",
        ack_dt: null,
        type: "SMPS Low input Voltage(Critical)",
        category: "Information",
        create_info: {
            description: "Low SMPS input Voltage",
        },
        device_id: "67689f77-f13e-469c-a162-14b5c23d5782",
        customer_id: "05988942-ed90-4f89-8ab6-e22191ac9532",
        acked_by: null,
        acked_info: null,
        is_active: false,
        severity: "CRITICAL",
        updated_dt: "2025-06-14T10:49:14.915741Z",
        clear_info: {
            description: "Values restored to Normal",
        },
        event_count: 31,
        create_value: {
            VIN: "0.00V",
        },
        clear_value: {
            VIN: "205.05V",
        },
        update_value: {
            VIN: "0.00V",
        },
        device: {
            id: "67689f77-f13e-469c-a162-14b5c23d5782",
            name: "NCR_PRYJ_DER_MTRC",
            is_test_mode: false,
            device_type_id: "e8d8d063-f465-409d-8a8a-2a57f1019247",
            is_logical: false,
            software_id: "f3d1f3ba-b167-4f16-a7e9-696f8c18d760",
            latitude: 28.5394405,
            longitude: 77.5373917,
            customer: null,
            device_type: {
                typeid: "e8d8d063-f465-409d-8a8a-2a57f1019247",
                type: "SMPS",
                label: "SMPS Charger",
            },
            software: {
                id: "f3d1f3ba-b167-4f16-a7e9-696f8c18d760",
                code: "MTRC System",
                alias: "MTRC System",
                additional_info: null,
            },
        },
        customer: {
            id: "05988942-ed90-4f89-8ab6-e22191ac9532",
            zone: "NCR",
            division: "PRYJ",
            station: "DER",
            title: null,
            devices: null,
        },
        acked_user: null,
        fmeas: null,
    },
    {
        id: "54a36575-7e46-4d08-9166-95929c484ef2",
        created_dt: "2025-06-14T08:11:59.824745Z",
        clear_dt: "2025-06-14T09:33:09.181974Z",
        ack_dt: null,
        type: "SMPS Low input Voltage(Critical)",
        category: "Information",
        create_info: {
            description: "Low SMPS input Voltage",
        },
        device_id: "67689f77-f13e-469c-a162-14b5c23d5782",
        customer_id: "05988942-ed90-4f89-8ab6-e22191ac9532",
        acked_by: null,
        acked_info: null,
        is_active: false,
        severity: "CRITICAL",
        updated_dt: "2025-06-14T09:09:14.528114Z",
        clear_info: {
            description: "Values restored to Normal",
        },
        event_count: 32,
        create_value: {
            VIN: "0.00V",
        },
        clear_value: {
            VIN: "205.94V",
        },
        update_value: {
            VIN: "0.00V",
        },
        device: {
            id: "67689f77-f13e-469c-a162-14b5c23d5782",
            name: "NCR_PRYJ_DER_MTRC",
            is_test_mode: false,
            device_type_id: "e8d8d063-f465-409d-8a8a-2a57f1019247",
            is_logical: false,
            software_id: "f3d1f3ba-b167-4f16-a7e9-696f8c18d760",
            latitude: 28.5394405,
            longitude: 77.5373917,
            customer: null,
            device_type: {
                typeid: "e8d8d063-f465-409d-8a8a-2a57f1019247",
                type: "SMPS",
                label: "SMPS Charger",
            },
            software: {
                id: "f3d1f3ba-b167-4f16-a7e9-696f8c18d760",
                code: "MTRC System",
                alias: "MTRC System",
                additional_info: null,
            },
        },
        customer: {
            id: "05988942-ed90-4f89-8ab6-e22191ac9532",
            zone: "NCR",
            division: "PRYJ",
            station: "DER",
            title: null,
            devices: null,
        },
        acked_user: null,
        fmeas: null,
    },
    {
        id: "1f92c50f-4fa0-48d2-94c4-7d5b066fdb75",
        created_dt: "2025-06-14T04:39:59.910049Z",
        clear_dt: "2025-06-14T06:06:24.081283Z",
        ack_dt: null,
        type: "SMPS Low output Voltage(Warning)",
        category: "Prediction",
        create_info: {
            description: "Low SMPS output Voltage",
        },
        device_id: "67689f77-f13e-469c-a162-14b5c23d5782",
        customer_id: "05988942-ed90-4f89-8ab6-e22191ac9532",
        acked_by: null,
        acked_info: null,
        is_active: false,
        severity: "WARNING",
        updated_dt: null,
        clear_info: {
            description: "Values restored to Normal",
        },
        event_count: 1,
        create_value: {
            VOUT: "47.40V",
        },
        clear_value: {
            VOUT: "48.65V",
        },
        update_value: null,
        device: {
            id: "67689f77-f13e-469c-a162-14b5c23d5782",
            name: "NCR_PRYJ_DER_MTRC",
            is_test_mode: false,
            device_type_id: "e8d8d063-f465-409d-8a8a-2a57f1019247",
            is_logical: false,
            software_id: "f3d1f3ba-b167-4f16-a7e9-696f8c18d760",
            latitude: 28.5394405,
            longitude: 77.5373917,
            customer: null,
            device_type: {
                typeid: "e8d8d063-f465-409d-8a8a-2a57f1019247",
                type: "SMPS",
                label: "SMPS Charger",
            },
            software: {
                id: "f3d1f3ba-b167-4f16-a7e9-696f8c18d760",
                code: "MTRC System",
                alias: "MTRC System",
                additional_info: null,
            },
        },
        customer: {
            id: "05988942-ed90-4f89-8ab6-e22191ac9532",
            zone: "NCR",
            division: "PRYJ",
            station: "DER",
            title: null,
            devices: null,
        },
        acked_user: null,
        fmeas: null,
    },
    {
        id: "bf013fef-6205-4ec7-95c1-a1c84b738a61",
        created_dt: "2025-06-14T04:39:57.315335Z",
        clear_dt: "2025-06-14T06:22:31.304237Z",
        ack_dt: null,
        type: "SMPS Low input Voltage(Critical)",
        category: "Information",
        create_info: {
            description: "Low SMPS input Voltage",
        },
        device_id: "67689f77-f13e-469c-a162-14b5c23d5782",
        customer_id: "05988942-ed90-4f89-8ab6-e22191ac9532",
        acked_by: null,
        acked_info: null,
        is_active: false,
        severity: "CRITICAL",
        updated_dt: "2025-06-14T04:39:57.906025Z",
        clear_info: {
            description: "Values restored to Normal",
        },
        event_count: 2,
        create_value: {
            VIN: "0.00V",
        },
        clear_value: {
            VIN: "208.00V",
        },
        update_value: {
            VIN: "0.00V",
        },
        device: {
            id: "67689f77-f13e-469c-a162-14b5c23d5782",
            name: "NCR_PRYJ_DER_MTRC",
            is_test_mode: false,
            device_type_id: "e8d8d063-f465-409d-8a8a-2a57f1019247",
            is_logical: false,
            software_id: "f3d1f3ba-b167-4f16-a7e9-696f8c18d760",
            latitude: 28.5394405,
            longitude: 77.5373917,
            customer: null,
            device_type: {
                typeid: "e8d8d063-f465-409d-8a8a-2a57f1019247",
                type: "SMPS",
                label: "SMPS Charger",
            },
            software: {
                id: "f3d1f3ba-b167-4f16-a7e9-696f8c18d760",
                code: "MTRC System",
                alias: "MTRC System",
                additional_info: null,
            },
        },
        customer: {
            id: "05988942-ed90-4f89-8ab6-e22191ac9532",
            zone: "NCR",
            division: "PRYJ",
            station: "DER",
            title: null,
            devices: null,
        },
        acked_user: null,
        fmeas: null,
    },
    {
        id: "29918236-bf08-4c7c-ac62-de0f9b334f40",
        created_dt: "2025-06-13T05:15:05.594352Z",
        clear_dt: "2025-06-13T06:21:14.944654Z",
        ack_dt: null,
        type: "SMPS Low output Voltage(Critical)",
        category: "Information",
        create_info: {
            description: "Low SMPS output Voltage",
        },
        device_id: "67689f77-f13e-469c-a162-14b5c23d5782",
        customer_id: "05988942-ed90-4f89-8ab6-e22191ac9532",
        acked_by: null,
        acked_info: null,
        is_active: false,
        severity: "CRITICAL",
        updated_dt: "2025-06-13T05:15:48.12178Z",
        clear_info: {
            description: "Values restored to Normal",
        },
        event_count: 6,
        create_value: {
            VOUT: "46.98V",
        },
        clear_value: {
            VOUT: "48.79V",
        },
        update_value: {
            VOUT: "46.70V",
        },
        device: {
            id: "67689f77-f13e-469c-a162-14b5c23d5782",
            name: "NCR_PRYJ_DER_MTRC",
            is_test_mode: false,
            device_type_id: "e8d8d063-f465-409d-8a8a-2a57f1019247",
            is_logical: false,
            software_id: "f3d1f3ba-b167-4f16-a7e9-696f8c18d760",
            latitude: 28.5394405,
            longitude: 77.5373917,
            customer: null,
            device_type: {
                typeid: "e8d8d063-f465-409d-8a8a-2a57f1019247",
                type: "SMPS",
                label: "SMPS Charger",
            },
            software: {
                id: "f3d1f3ba-b167-4f16-a7e9-696f8c18d760",
                code: "MTRC System",
                alias: "MTRC System",
                additional_info: null,
            },
        },
        customer: {
            id: "05988942-ed90-4f89-8ab6-e22191ac9532",
            zone: "NCR",
            division: "PRYJ",
            station: "DER",
            title: null,
            devices: null,
        },
        acked_user: null,
        fmeas: null,
    },
    {
        id: "0e6b92e8-f6bf-46a5-a5a2-e0dc9a0b7926",
        created_dt: "2025-06-13T05:05:37.234185Z",
        clear_dt: "2025-06-13T06:23:27.511433Z",
        ack_dt: null,
        type: "SMPS Low input Voltage(Critical)",
        category: "Information",
        create_info: {
            description: "Low SMPS input Voltage",
        },
        device_id: "67689f77-f13e-469c-a162-14b5c23d5782",
        customer_id: "05988942-ed90-4f89-8ab6-e22191ac9532",
        acked_by: null,
        acked_info: null,
        is_active: false,
        severity: "CRITICAL",
        updated_dt: "2025-06-13T05:15:46.12134Z",
        clear_info: {
            description: "Values restored to Normal",
        },
        event_count: 13,
        create_value: {
            VIN: "0.00V",
        },
        clear_value: {
            VIN: "205.05V",
        },
        update_value: {
            VIN: "0.00V",
        },
        device: {
            id: "67689f77-f13e-469c-a162-14b5c23d5782",
            name: "NCR_PRYJ_DER_MTRC",
            is_test_mode: false,
            device_type_id: "e8d8d063-f465-409d-8a8a-2a57f1019247",
            is_logical: false,
            software_id: "f3d1f3ba-b167-4f16-a7e9-696f8c18d760",
            latitude: 28.5394405,
            longitude: 77.5373917,
            customer: null,
            device_type: {
                typeid: "e8d8d063-f465-409d-8a8a-2a57f1019247",
                type: "SMPS",
                label: "SMPS Charger",
            },
            software: {
                id: "f3d1f3ba-b167-4f16-a7e9-696f8c18d760",
                code: "MTRC System",
                alias: "MTRC System",
                additional_info: null,
            },
        },
        customer: {
            id: "05988942-ed90-4f89-8ab6-e22191ac9532",
            zone: "NCR",
            division: "PRYJ",
            station: "DER",
            title: null,
            devices: null,
        },
        acked_user: null,
        fmeas: null,
    },
    {
        id: "c3d605d8-887f-44fc-bdd2-c1c16362c7dd",
        created_dt: "2025-06-13T04:31:56.814663Z",
        clear_dt: "2025-06-13T04:53:03.125062Z",
        ack_dt: null,
        type: "SMPS Low input Voltage(Critical)",
        category: "Information",
        create_info: {
            description: "Low SMPS input Voltage",
        },
        device_id: "292ae68e-3a5b-4f38-b578-9f63d3dd07d1",
        customer_id: "05988942-ed90-4f89-8ab6-e22191ac9532",
        acked_by: null,
        acked_info: null,
        is_active: false,
        severity: "CRITICAL",
        updated_dt: "2025-06-13T04:37:45.019205Z",
        clear_info: {
            description: "Values restored to Normal",
        },
        event_count: 7,
        create_value: {
            VIN: "0.00V",
        },
        clear_value: {
            VIN: "209.47V",
        },
        update_value: {
            VIN: "0.00V",
        },
        device: {
            id: "292ae68e-3a5b-4f38-b578-9f63d3dd07d1",
            name: "NCR_PRYJ_DER_EXCHANGE",
            is_test_mode: false,
            device_type_id: "e8d8d063-f465-409d-8a8a-2a57f1019247",
            is_logical: false,
            software_id: "a5e23c53-9b72-4af2-8f69-9e450cba5651",
            latitude: 28.5392797,
            longitude: 77.537247,
            customer: null,
            device_type: {
                typeid: "e8d8d063-f465-409d-8a8a-2a57f1019247",
                type: "SMPS",
                label: "SMPS Charger",
            },
            software: {
                id: "a5e23c53-9b72-4af2-8f69-9e450cba5651",
                code: "Auto Exchange",
                alias: "Auto Exchange",
                additional_info: null,
            },
        },
        customer: {
            id: "05988942-ed90-4f89-8ab6-e22191ac9532",
            zone: "NCR",
            division: "PRYJ",
            station: "DER",
            title: null,
            devices: null,
        },
        acked_user: null,
        fmeas: null,
    },
    {
        id: "028c2c24-d573-438e-8492-bddbdecae17f",
        created_dt: "2025-06-10T07:27:07.094702Z",
        clear_dt: "2025-06-10T07:48:19.729352Z",
        ack_dt: null,
        type: "SMPS Low output Voltage(Critical)",
        category: "Information",
        create_info: {
            description: "Low SMPS output Voltage",
        },
        device_id: "67689f77-f13e-469c-a162-14b5c23d5782",
        customer_id: "05988942-ed90-4f89-8ab6-e22191ac9532",
        acked_by: null,
        acked_info: null,
        is_active: false,
        severity: "CRITICAL",
        updated_dt: "2025-06-10T07:33:09.200173Z",
        clear_info: {
            description: "Values restored to Normal",
        },
        event_count: 5,
        create_value: {
            VOUT: "46.98V",
        },
        clear_value: {
            VOUT: "56.30V",
        },
        update_value: {
            VOUT: "46.15V",
        },
        device: {
            id: "67689f77-f13e-469c-a162-14b5c23d5782",
            name: "NCR_PRYJ_DER_MTRC",
            is_test_mode: false,
            device_type_id: "e8d8d063-f465-409d-8a8a-2a57f1019247",
            is_logical: false,
            software_id: "f3d1f3ba-b167-4f16-a7e9-696f8c18d760",
            latitude: 28.5394405,
            longitude: 77.5373917,
            customer: null,
            device_type: {
                typeid: "e8d8d063-f465-409d-8a8a-2a57f1019247",
                type: "SMPS",
                label: "SMPS Charger",
            },
            software: {
                id: "f3d1f3ba-b167-4f16-a7e9-696f8c18d760",
                code: "MTRC System",
                alias: "MTRC System",
                additional_info: null,
            },
        },
        customer: {
            id: "05988942-ed90-4f89-8ab6-e22191ac9532",
            zone: "NCR",
            division: "PRYJ",
            station: "DER",
            title: null,
            devices: null,
        },
        acked_user: null,
        fmeas: null,
    },
    {
        id: "45bf40f5-7f84-4990-9c86-6247fa64fff4",
        created_dt: "2025-06-10T06:29:00.379419Z",
        clear_dt: "2025-06-10T07:47:51.037967Z",
        ack_dt: null,
        type: "SMPS Low input Voltage(Critical)",
        category: "Information",
        create_info: {
            description: "Low SMPS input Voltage",
        },
        device_id: "67689f77-f13e-469c-a162-14b5c23d5782",
        customer_id: "05988942-ed90-4f89-8ab6-e22191ac9532",
        acked_by: null,
        acked_info: null,
        is_active: false,
        severity: "CRITICAL",
        updated_dt: "2025-06-10T07:31:01.258449Z",
        clear_info: {
            description: "Values restored to Normal",
        },
        event_count: 36,
        create_value: {
            VIN: "0.00V",
        },
        clear_value: {
            VIN: "216.25V",
        },
        update_value: {
            VIN: "0.00V",
        },
        device: {
            id: "67689f77-f13e-469c-a162-14b5c23d5782",
            name: "NCR_PRYJ_DER_MTRC",
            is_test_mode: false,
            device_type_id: "e8d8d063-f465-409d-8a8a-2a57f1019247",
            is_logical: false,
            software_id: "f3d1f3ba-b167-4f16-a7e9-696f8c18d760",
            latitude: 28.5394405,
            longitude: 77.5373917,
            customer: null,
            device_type: {
                typeid: "e8d8d063-f465-409d-8a8a-2a57f1019247",
                type: "SMPS",
                label: "SMPS Charger",
            },
            software: {
                id: "f3d1f3ba-b167-4f16-a7e9-696f8c18d760",
                code: "MTRC System",
                alias: "MTRC System",
                additional_info: null,
            },
        },
        customer: {
            id: "05988942-ed90-4f89-8ab6-e22191ac9532",
            zone: "NCR",
            division: "PRYJ",
            station: "DER",
            title: null,
            devices: null,
        },
        acked_user: null,
        fmeas: null,
    },
];

const getInitFilterFrom = () => {
    let zone_ids: any[] = [];
    let div_ids: any[] = [];
    let customer: any = { id: "", value: "" };
    return {
        zone_ids,
        div_ids,
        customer: customer,
    };
};

const getPlatformSvg = async (customer_id: string) => {
    try {
        const API_URL = `${APP_BASE_URL}${PLATFORM_SVG_FOR_STATION}`;
        const params = {
            category: "PLATFORM_CONFIG",
            customerIdList: [customer_id].toString(),
        };
        const res = await axios.get(API_URL, { params });
        const svgData = res.data?.data?.[0];
        if (!svgData) {
            throw new Error("Platform Layout not uploaded for this station");
        }
        const [_, _stationId, _category, __, svgContent] = svgData;
        return svgContent;
    } catch (error: any) {
        let error_msg;
        if (axios.isAxiosError(error)) {
            error_msg = error.response?.statusText || "Something went wrong";
        } else {
            error_msg = error.message || "Something went wrong";
        }
        toast.error(error_msg);
        console.error(error);
        return null;
    }
};

const getAllActiveAlarms = async (params: Record<string, any>) => {
    //   return dummyAlarm;
    // const API_URL = `${APP_BASE_URL_ALARM}${GET_PAGINATED_ALARMS}`;
    const API_URL = `${APP_BASE_URL_ALARM}${GET_ACTIVE_ALARMS}`;

    // const params = {
    //     limit: 100,
    //     offset: 0,
    //     customer_ids: [customer_id].toString(),
    //     with_device: true,
    //     with_software: true,
    // };
    // const params = {
    //     customer_ids: [customer_id].toString(),
    //     with_device: true,
    //     with_software: true,
    // };
    const res = await axios.get(API_URL, { params });
    // const alarms = res.data;
    const alarms = res.data.alarms;
    console.log(alarms);
    return alarms;
};

const platformSvgDeviceTypeComponents = ["CGDB", "PDC", "AGDB", "SLDB", "COLOUM SPEAKER", "CAMERA"];

type AlarmInfoType = Record<
    string,
    {
        alarmCount: number;
        device_type: string;
        software: string;
        deviceName: string;
    }
>;

function PlatformSvg() {
    const [filterForm, setFilterForm] = useImmer(() => getInitFilterFrom());
    const [tooltipState, setTooltipState] = useState<{ top: number; left: number; id: string } | null>(null);
    const { data: gearTypesList = [] } = useGetDeviceTypesQuery(null);
    const user_permissions = getParsedLocalStorage("permissions");
    const selectedCustomersList = useSelector(selectedCustomersSelector);
    const [platformSvg, setPlatformSvg] = useState("");
    const [loading, setLoading] = useState(false);
    const socketRef = useRef<WebSocket | null>();

    const [activeAlarms, setActiveAlarms] = useState<AlarmInfoType>({});
    const activeAlarmRef = useRef<AlarmInfoType>({});
    const alarmDataUpdatedRef = useRef(false);
    const svgParentRef = useRef<HTMLDivElement>(null!);

    const permittedCustomerIds = useMemo(() => {
        const _list = selectedCustomersList;
        if (!_list) return [];
        return _list.map((customer) => customer.customerId);
    }, [selectedCustomersList]);
    const parsedPermissions = useMemo(() => {
        return extractParsedDataFromPermissions(user_permissions);
    }, []);

    const handleFilterChange = (filter_key: string, filter_value: any) => {
        setFilterForm((prev: any) => {
            prev[filter_key] = filter_value;
        });
    };

    const zone_dd = useMemo(() => parsedPermissions.zones, []);

    const div_dd = useMemo(() => {
        let total_divs = parsedPermissions.divisions;
        if (filterForm.zone_ids.length) {
            const ids = filterForm.zone_ids.map((obj) => obj.id);
            total_divs = parsedPermissions.divisions.filter((div_obj) => ids.includes(div_obj.zone.id));
            const filtered_form_div_ids = filterForm.div_ids.filter((selected_div_obj) => {
                return total_divs.find((obj) => obj.id === selected_div_obj.id);
            });
            setFilterForm((prev) => {
                prev.div_ids = filtered_form_div_ids;
            });
        }

        return total_divs;
    }, [filterForm.zone_ids]);

    const customer_dd = useMemo(() => {
        let filtered_stations = parsedPermissions.stations.filter((obj) => permittedCustomerIds.includes(obj.id));
        if (filterForm.div_ids.length) {
            const selected_div_ids = filterForm.div_ids.map((obj) => obj.id);
            filtered_stations = filtered_stations.filter((stationObj) => selected_div_ids.includes(stationObj.division.id));
        } else if (filterForm.zone_ids.length) {
            const selected_zone_ids = filterForm.zone_ids.map((obj) => obj.id);
            filtered_stations = filtered_stations.filter((stationObj) => selected_zone_ids.includes(stationObj.zone.id));
        }
        const filtered_form_stn_id = filtered_stations.find((obj) => obj.id === filterForm.customer?.id) || {
            id: "",
            value: "",
        };

        setFilterForm((prev) => {
            prev.customer = filtered_form_stn_id;
        });
        return filtered_stations;
    }, [permittedCustomerIds, filterForm.div_ids, filterForm.zone_ids]);

    const findStationSvgAndData = async () => {
        let toastId;
        try {
            if (socketRef.current) {
                socketRef.current.close();
                socketRef.current = null;
            }
            setLoading(true);
            toastId = toast.loading("Loading station data");
            // fetch svg for station id
            if (!filterForm.customer.id) {
                toast.error("Please select a station")
                return;
            }
            const platformSvg = await getPlatformSvg(filterForm.customer.id);
            if (!platformSvg) return;
            setPlatformSvg(platformSvg);

            const params = {
                customer_ids: [filterForm.customer.id].toString(),
                with_device: true,
                with_software: true,
                // limit: 100,
                // offset: 0,
                device_type_ids: gearTypesList
                    .filter((gearType: { id: string; value: string }) => platformSvgDeviceTypeComponents.includes(gearType.value))
                    .map((gearType: { id: string; value: string }) => gearType.id)
                    .toString(),
            };
            const alarms = await getAllActiveAlarms(params);
            if (alarms && Array.isArray(alarms)) {
                const alarmObj: any = {};
                alarms.forEach((alarm: any) => {
                    const name = alarm.device.name;
                    const [_zone, _div, ...rest] = name.split("_");
                    const deviceName = rest.join("-");
                    alarmObj[deviceName] = {
                        alarmCount: (alarmObj?.[deviceName]?.alarmCount || 0) + 1,
                        device_type: alarm.device.device_type.label,
                        software: alarm.device.software.alias,
                        deviceName,
                    };
                });
                setActiveAlarms(alarmObj);
                activeAlarmRef.current = alarmObj;

            }
            setUpAlarmWebsocket(filterForm.customer.id);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
            toast.dismiss(toastId)
        }
    };

    useEffect(() => {
        setInterval(() => {
            if (alarmDataUpdatedRef.current) {
                setActiveAlarms({ ...activeAlarmRef.current });
                alarmDataUpdatedRef.current = false;
            }
        }, 1000);
    }, []);

    const setUpAlarmWebsocket = (customer_id: string) => {
        if (!customer_id) return;
        const isNewAlarm = (alarm: any) => alarm.created_dt && !alarm.clear_dt;
        const isAlarmUpdated = (alarm: any) => alarm.created_dt && alarm.updated_dt && !alarm.clear_dt;
        const isAlarmClosed = (alarm: any) => alarm.created_dt && alarm.updated_dt && alarm.clear_dt;

        const handleWebsocketAlarmMessage = (alarm_packet: any) => {
            const name = alarm_packet.device.name;
            const [_zone, _div, ...rest] = name.split("_");
            const deviceName: string = rest.join("-");

            if (isAlarmClosed(alarm_packet)) {
                alarmDataUpdatedRef.current = true;
                if (activeAlarmRef.current[deviceName]) {
                    if (activeAlarmRef.current[deviceName].alarmCount > 1) {
                        activeAlarmRef.current[deviceName].alarmCount = activeAlarmRef.current[deviceName].alarmCount - 1;
                        return;
                    }
                    delete activeAlarmRef.current[deviceName];
                    setTooltipState(null);
                }
                return;
            }

            if (isNewAlarm(alarm_packet)) {
                alarmDataUpdatedRef.current = true;
                if (activeAlarmRef.current[deviceName]) {
                    activeAlarmRef.current[deviceName].alarmCount = activeAlarmRef.current[deviceName].alarmCount + 1;
                } else {
                    activeAlarmRef.current[deviceName] = {
                        alarmCount: 1,
                        device_type: alarm_packet.device.device_type.label,
                        software: alarm_packet.device.software.alias,
                        deviceName,
                    };
                }
                return;
            }
        };
        function websocketConnect() {
            const url = `${APP_BASE_URL_ALARM_SOCKET + ALARM_WEBSOCKET_PATH}/ALARMS?customer_ids=${customer_id}`;
            socketRef.current = new WebSocket(url);

            socketRef.current.onmessage = (event) => {
                const alarm = JSON.parse(event.data);
                if (!alarm) return;
                handleWebsocketAlarmMessage(alarm);
            };

            socketRef.current.onerror = function () {
                socketRef?.current?.close?.();
            };
        }
        websocketConnect();
    };

    useEffect(() => {
        if (platformSvg) {
            syncPlatformSvg();
        }
    }, [activeAlarms, platformSvg]);

    const syncPlatformSvg = () => {
        // first get all text icons and fill it with green color.
        const iconElements = svgParentRef.current.querySelectorAll('[id$="_ICON"]');

        iconElements.forEach((iconElement: any) => {
            // iconElement.setAttribute("fill", "#79ff79");
            iconElement.style.fill = "#79ff79"
        });

        // then from activeAlarms get all the elements where alarm are there
        const activeAlarmSelector = Object.keys(activeAlarms);
        if (!activeAlarmSelector?.length) return;
        activeAlarmSelector.forEach((alarmSelector) => {
            const svgElement = svgParentRef.current.querySelector(`[id*="${alarmSelector}"]`);
            if (svgElement) {
                // in its icon fill color red
                const iconElement = svgElement.querySelector("[id$='_ICON']");
                iconElement?.setAttribute("fill", "red");
                // const or = document.getElementById("coords");

                svgElement.setAttribute("data-tooltip", alarmSelector);

                svgElement.addEventListener("mouseenter", (e: any) => {
                    const id: any = svgElement.getAttribute("id") ?? null;
                    if (activeAlarmRef.current[id]) {
                        setTooltipState({
                            id,
                            left: e.clientX,
                            top: e.clientY,
                        });
                    }

                    // const closestElementId = e.target.closest('[data-tooltip]').id;

                    // const coords = `X: ${e.clientX}, Y: ${e.clientY}`;
                    // if (or) {
                    //     or.textContent = coords
                    //     or.style.left = (e.clientX + 20) + "px";
                    //     or.style.top = (e.clientY + 20) + "px";
                    //     or.style.display = "block";
                    // }
                });

                document.addEventListener("click", () => {
                    setTooltipState(null);
                });

                // svgElement.addEventListener("mouseleave", (e: any) => {
                // if (!svgElement.contains(e.relatedTarget)) {
                //     console.group("a")
                //     console.log(e.currentTarget.id, "HIDDEN SVG FOR THIS ELEMENT");
                //     console.log(svgElement.contains(e.relatedTarget))
                //     console.dir(svgElement)
                //     console.dir(e.relatedTarget)
                //     console.groupEnd()
                // }
                // })
            }
        });
    };

    return (
        <div className="platform-container">
            <div className="platform-filter-container">
                <Autocomplete
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    multiple
                    className="filter-form-item"
                    options={zone_dd ?? []}
                    value={filterForm.zone_ids || []}
                    onChange={(_, newValue) => {
                        handleFilterChange("zone_ids", newValue);
                    }}
                    disableCloseOnSelect
                    getOptionLabel={(opt) => opt.value}
                    renderInput={(params) => <TextField {...params} label="Zones" />}
                    renderTags={(value, getTagProps) => {
                        return (
                            <div>
                                <Chip size="small" variant="outlined" label={value[0].value} {...getTagProps({ index: 0 })} />
                                {value.length > 1 && (
                                    <AutocompleteStationListPop title={value.map((option) => option?.value ?? "").toString()}>
                                        <Chip size="small" label={`+${value.length - 1}`} />
                                    </AutocompleteStationListPop>
                                )}
                            </div>
                        );
                    }}
                />
                <Autocomplete
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    multiple
                    disableCloseOnSelect
                    className="filter-form-item"
                    options={div_dd ?? []}
                    value={filterForm.div_ids || []}
                    onChange={(_, newValue) => {
                        handleFilterChange("div_ids", newValue);
                    }}
                    getOptionLabel={(opt) => opt.value}
                    renderInput={(params) => <TextField {...params} label="Divisions" />}
                    renderTags={(value, getTagProps) => {
                        return (
                            <div>
                                <Chip size="small" variant="outlined" label={value[0].value} {...getTagProps({ index: 0 })} />
                                {value.length > 1 && (
                                    <AutocompleteStationListPop title={value.map((option) => option?.value ?? "").toString()}>
                                        <Chip size="small" label={`+${value.length - 1}`} />
                                    </AutocompleteStationListPop>
                                )}
                            </div>
                        );
                    }}
                />
                <Autocomplete
                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                    multiple={false}
                    className="filter-form-item"
                    options={customer_dd ?? []}
                    value={filterForm.customer}
                    onChange={(_, newValue) => {
                        handleFilterChange("customer", newValue);
                    }}
                    getOptionLabel={(opt) => opt?.value || ""}
                    renderInput={(params) => <TextField {...params} label="Stations" />}
                    renderTags={(value, getTagProps) => {
                        return (
                            <div>
                                <Chip size="small" variant="outlined" label={value[0].value} {...getTagProps({ index: 0 })} />
                                {value.length > 1 && (
                                    <AutocompleteStationListPop title={value.map((option) => option?.value ?? "").toString()}>
                                        <Chip size="small" label={`+${value.length - 1}`} />
                                    </AutocompleteStationListPop>
                                )}
                            </div>
                        );
                    }}
                />

                <Button variant="contained" onClick={findStationSvgAndData} disabled={loading}>
                    Find
                </Button>
            </div>
            <div className="platform-svg-container">
                {
                    platformSvg ?
                        <>
                            <div ref={svgParentRef} dangerouslySetInnerHTML={{ __html: platformSvg }}></div>
                            {tooltipState?.id && (
                                <div
                                    id="coords"
                                    className="tooltip"
                                    style={{
                                        top: tooltipState.top,
                                        left: tooltipState.left,
                                    }}
                                >
                                    <Typography variant="body2">Active Alarms : {activeAlarms?.[tooltipState?.id].alarmCount}</Typography>
                                    <Typography variant="body2">Device Name : {activeAlarms?.[tooltipState?.id].deviceName}</Typography>
                                    <Typography variant="body2">Device Type : {activeAlarms?.[tooltipState?.id].device_type}</Typography>
                                    <Typography variant="body2">Software : {activeAlarms?.[tooltipState?.id].software}</Typography>
                                </div>
                            )}
                        </>
                        : <div className="fullWidth flex-col fullHeight flex justifyCenter alignCenter gap-16">
                            <TravelExploreIcon sx={{ fontSize: "100px", color: "grey" }} />
                            <Typography variant="h5">Please select a station to load Alarms</Typography>
                        </div>
                }
            </div>
        </div>
    );
}

export default PlatformSvg;
